// Libraries
var React = require("react");

// Style
require("../Cta/Cta.scss");

class CustomCtaModule extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        className={`c-section c-section--gutter c-section--always-padded c-cta ${
          this.props.data.isPremium ? " c-cta--premium" : ""
        }`}
        id={this.props.data.id}
      >
        <div className="c-cta__inner">
          <div className="c-section__inner">
          {this.props.data.title ?
            <h2 className="c-cta__title">{this.props.data.title}</h2>
          : null}
          {this.props.data.subheading ?
            <p className="c-cta__subheading">{this.props.data.subheading}</p>
          : null}

            {this.props.data.button.url && this.props.data.button.caption ?
              <div className="c-cta__button-only">
                            <a href={this.props.data.button.url}
                                target={this.props.data.button.newWindow ? "_blank" : "_self"}
                                className={`c-button ${this.props.data.isPremium ? " c-button--premium" : ""
                                    }`}
                                rel={this.props.data.button.newWindow ? "noopener noreferrer" : undefined}
                >
                  {this.props.data.button.caption}
                </a>
              </div>
            : null}

            {this.props.data.phoneNumber ?
               <p className="c-cta__phone-number-container">
                <a
                  href={`tel:${this.props.data.phoneNumber}`}
                  className="c-cta__phone-number"
                >
                  {this.props.data.phoneNumber}
                </a>
              </p>
            : null}
            
          </div>
        </div>
      </div>
    );
  }
}

module.exports = CustomCtaModule;



// WEBPACK FOOTER //
// ./src/components/CustomCta/Cta.js